export { default } from './HoldingDetailsFlyout';
